import { singleton } from 'tsyringe';
import { LoggerService } from 'app-core/src/services/logger.service';
import { OWPlugin } from '../../../odk-ts';
import { kNameOfSimpleIOPlugin } from 'app-core/src/constants/constants';
import { IOwSimpleIoPlugin } from './simple-plugin.interface';

// -----------------------------------------------------------------------------
@singleton()
export class OwSimplePluginService {
  private readonly logger = LoggerService.getCategory('OwSimplePluginService');

  private simpleIoInstance: IOwSimpleIoPlugin;

  // ---------------------------------------------------------------------------
  public constructor() {
    this.init();
  }

  // ---------------------------------------------------------------------------
  public async getRegistryKey(
    registryStore: 'LocalMachine' | 'CurrentUser' | 'ClassesRoot' | 'users',
    key: string,
    value: string,
  ) {
    return new Promise<any>((resolve) => {
      try {
        this.simpleIoInstance.RegistryGetKeyValue(
          registryStore,
          key,
          value,
          (status, data) => {
            if (!status) {
              resolve(null);
              return;
            }

            resolve(data);
          },
        );
      } catch (error) {
        this.logger.error(
          'Error during download plugin initialization ',
          error,
        );

        resolve(null);
      }
    });
  }

  // ---------------------------------------------------------------------------
  public async getRegistryKeyList(
    registryStore: 'LocalMachine' | 'CurrentUser' | 'ClassesRoot' | 'users',
    key: string,
  ) {
    return new Promise<any>((resolve) => {
      try {
        this.simpleIoInstance.RegistryGetKeys(
          registryStore,
          key,
          (status, data) => {
            if (!status) {
              resolve(null);
              return;
            }

            resolve(data);
          },
        );
      } catch (error) {
        this.logger.error(
          'Error during download plugin initialization ',
          error,
        );

        resolve(null);
      }
    });
  }

  // ---------------------------------------------------------------------------
  private async init() {
    try {
      const plugin = await OWPlugin.create(kNameOfSimpleIOPlugin);
      if (!plugin.isInitialized || !plugin?.instance) {
        throw new Error('Error obtaining download plugin');
      }

      this.simpleIoInstance = plugin?.instance;
    } catch (error) {
      this.logger.error('Error during download plugin initialization ', error);
    }
  }
}
